export default "__VITE_ASSET__4b474e40__"